import { render } from "./TheKeyOfSuccess.vue?vue&type=template&id=79165c72&scoped=true"
import script from "./TheKeyOfSuccess.vue?vue&type=script&lang=js"
export * from "./TheKeyOfSuccess.vue?vue&type=script&lang=js"

import "./TheKeyOfSuccess.vue?vue&type=style&index=0&id=79165c72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79165c72"],['__file',"TheKeyOfSuccess.vue"]])

export default __exports__